import Service from "../Service";
import AppointmentTypeService from "./AppointmentTypeService";
import AppointmentType from "../AppointmentType";
import AccountService from "./AccountService";
import PersistentData from "../PersistentData";
import User from '../User';
import LoadQueue from "../../classes/LoadQueue";
import Doctor from "../Doctor";
import FollowUpService from "./FollowUpService";


const account = new AccountService();

export default class ClinicService extends Service{
	constructor(){
		super(true, 'ClinicData');
	}
	getInfo(id, cb){
		return AppointmentTypeService.LoadCats(id).then(() => {
			return this.request('Clinic/' + id, {
				headers:{
					clinicId:id
				},
				cache_function: (data) => {
					let appTypes = data.appointmentTypes;
					let cache = AppointmentTypeService.GetTypeCache(id);
					for(let i=0; i < appTypes.length; i++){
						let app = new AppointmentType(appTypes[i]);
						cache.setData(app.appointmentTypeId, app);
					}

					let doctors = data.userClinics;

					for(let i=0; i < doctors.length; i++){
						let doc = doctors[i].user;
						this.cache.setData('Clinic/' + id + '/Doctor/' + doc.userId, doc);
					}

					this.cache.setData('Clinic/' + id + '/preferences', JSON.parse(data.preferences || '{}'));

				}
			})
		})
	}

	static ClearAllClinicCache(){
		const pd = new PersistentData('ClinicData/Clinic');
		pd.clear();
	}

	static GetDoctors(clinicId, useCache){
		let cache = new PersistentData(this.GetCachePath(clinicId) + '/Doctor/');
		let drList = cache.getAll().filter(dr => dr.status === 'active');
		if(useCache)return drList;
		return Promise.resolve(drList);
	}

	static GetCachePath(clinicId){
		return 'ClinicData/Clinic/' + (clinicId || account.clinicId)
	}
	static GetCache(clinicId){
		return new PersistentData(this.GetCachePath(clinicId));
	}
	static GetDrCachePath(doctorId, clinicId){
		return this.GetCachePath(clinicId) + '/Doctor/' + (doctorId || account.userId);
	}

	static GetDrById(id, clinicId){
		let path = this.GetCachePath(clinicId);
		let cache = new PersistentData(path + '/Doctor');
		let user = cache.getData(id || account.userId);
		return new Doctor(user);
	}

	static LoadDoctorSchedules(clinicId){
		return new Promise((resolve, reject) =>{
			const queue = new LoadQueue();
			const doctors = this.GetDoctors(clinicId, true);
			queue.onComplete = resolve;
			for(let i=0; i < doctors.length; i++){
				let dr = new Doctor(doctors[i]);
				queue.add(() => {
					return {promise:dr.settings.schedule.load()}
				})
			}

			queue.add(() => {
				return {promise:FollowUpService.GetFollowUps()};
			});

			queue.start();
		})
	}

}



// WEBPACK FOOTER //
// ./src/api/services/ClinicService.js